export const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });


export const loadFont = async (font) => {
  try {
    const file = font.files?.[0];
    if (!file?.uri_full) {
      console.warn("Font file missing", font);
      return;
    }

    const fontFace = new FontFace(
      font.family,
      `url(${file.uri_full}) format("truetype")`,
      {
        weight: file.weight || "400",
        style: file.style || "normal",
      }
    );

    await fontFace.load();
    document.fonts.add(fontFace);

    console.log("Font loaded:", font.family);

  } catch (err) {
    console.error("Font load failed:", err);
  }
};


// utils/appHelper.js
// export const loadFont = (font) => {
//   return new Promise((resolve, reject) => {
//     if (!font?.files?.length) return resolve();

//     const face = new FontFace(
//       font.family,
//       `url(${font.files[0].uri_full})`,
//       { style: "normal", weight: "400" }
//     );

//     face.load()
//       .then((loadedFace) => {
//         document.fonts.add(loadedFace);
//         resolve();
//       })
//       .catch(reject);
//   });
// };

export const normalizeSlides = (slides) =>
  slides.map((slide) => ({
    ...slide,
    texts: slide.texts.map((t) => ({
      ...t,
      font_track: {
        family: t.font_track?.family || "serif",
        size: t.font_track?.size || 48,
        color: t.font_track?.color || "#000000",
        fallback: t.font_track?.fallback || "serif",
        files: t.font_track?.files || [],
        id: t.font_track?.id || null,
      },
    })),
  }));

/* =========================
   TEXT STYLE PREVIEW HELPER
========================= */
export const getTextPreviewStyle = (textStyle = {}) => {
  const style = {};

  if (textStyle?.shadow) {
    const shadowMap = {
      soft:   "0 1px 6px rgba(0,0,0,0.65)",
      medium: "0 2px 6px rgba(0,0,0,0.80), 0 0 14px rgba(0,0,0,0.55)",
      strong: "0 0 8px rgba(0,0,0,0.95), 0 2px 4px rgba(0,0,0,0.90), 0 0 22px rgba(0,0,0,0.75), 1px 1px 0 rgba(0,0,0,0.85), -1px -1px 0 rgba(0,0,0,0.85)",
    };
    style.textShadow = shadowMap[textStyle.shadow_intensity || "strong"];
  }

  if (textStyle?.backdrop) {
    const opacity = textStyle.backdrop_opacity ?? 0.45;
    style.backgroundColor = `rgba(0,0,0,${opacity})`;
    style.borderRadius = "8px";
    style.padding = "4px 10px";
    style.display = "inline-block";
  }

  return style;
};